import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  province: 'Buenos Aires',
  product: 'BIODECODIFICACION Integral'
}, {
  name: 'Carolina S.',
  province: 'Córdoba',
  product: 'BIODECODIFICACION Integral'
}, {
  name: 'Valentina R.',
  province: 'Santa Fe',
  product: 'BIODECODIFICACION Integral'
}, {
  name: 'Luciana M.',
  province: 'Mendoza',
  product: 'BIODECODIFICACION Integral'
}, {
  name: 'Florencia G.',
  province: 'Tucumán',
  product: 'BIODECODIFICACION Integral'
}, {
  name: 'Romina P.',
  province: 'Entre Ríos',
  product: 'BIODECODIFICACION Integral'
}, {
  name: 'Agustina D.',
  province: 'Salta',
  product: 'BIODECODIFICACION Integral'
}, {
  name: 'Camila T.',
  province: 'Neuquén',
  product: 'BIODECODIFICACION Integral'
}, {
  name: 'Daniela F.',
  province: 'Misiones',
  product: 'BIODECODIFICACION Integral'
}, {
  name: 'Sofía B.',
  province: 'Chaco',
  product: 'BIODECODIFICACION Integral'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 3;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    const initialDelay = setTimeout(() => setVisible(true), 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
      const nextDelay = Math.floor(Math.random() * 8000) + 12000;
      const showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, nextDelay);
      return () => clearTimeout(showTimer);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-[60] max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-238">
      <div className="bg-[#111111] border border-white/10 rounded-xl p-3.5 shadow-[0_8px_30px_rgba(0,0,0,0.5)] backdrop-blur-sm" data-id="element-239">
        <div className="flex items-start gap-3" data-id="element-240">
          <div className="w-9 h-9 rounded-full bg-[#eab308]/20 border border-[#eab308]/30 flex items-center justify-center flex-shrink-0" data-id="element-241">
            <span className="text-sm" data-id="element-242">✨</span>
          </div>
          <div className="min-w-0" data-id="element-243">
            <p className="text-white text-sm font-semibold leading-tight" data-id="element-244">
              {purchase.name}
              <span className="text-gray-400 font-normal" data-id="element-245"> de </span>
              <span className="text-[#eab308]" data-id="element-246">{purchase.province}</span>
            </p>
            <p className="text-gray-400 text-xs mt-0.5" data-id="element-247">
              adquirió{' '}
              <span className="text-gray-200 font-medium" data-id="element-248">
                {purchase.product}
              </span>
            </p>
            <p className="text-gray-500 text-[10px] mt-1" data-id="element-249">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}